module.exports = __webpack_public_path__ + "lato-bold-webfont.4bb94b012dceff51e182.ttf";


//////////////////
// WEBPACK FOOTER
// C:/WS/Fusion/FusionDashboard/resources/fonts/lato-bold-webfont.ttf
// module id = ../../../../../resources/fonts/lato-bold-webfont.ttf
// module chunks = styles